export const GET_CATEGORIES          = 'GET_CATEGORIES';
export const CHANGE_VALUES_FORM      = 'CHANGE_VALUES_FORM';
export const SELECTED_ITEMS_CONCEPTS = 'SELECTED_ITEMS_CONCEPTS';
export const SAVE_CATEGORY           = 'SAVE_CATEGORY';
export const GET_ITEM_CATEGORY       = 'GET_ITEM_CATEGORY';
export const DELETE_CONCEPT_CATEGORY = 'DELETE_CONCEPT_CATEGORY';
export const DELETE_CATEGORY         = 'DELETE_CATEGORY';
export const CATEGORY_DEFAULT_DATA   = 'CATEGORY_DEFAULT_DATA';